<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="d-block justify-content-between align-items-center">
  <h1 style="margin: 6px;">Feature Pivot Summary</h1>
</div>
<div class="featurePivotSummary">
  @if (tableRows.length > 0) {
    <p-table #pt [value]="tableRows" [lazy]="false" dataKey="property.shortTermRentalId"
      selectionMode="single" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col; let i = $index) {
            <th [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
              {{col.header}}
              @if (i < 2) {
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
              @if (i > 1) {
                <i class="pi pi-copy" aria-hidden="true"
                style="color:blue; font-size:110%; padding-right:20px;" (click)="copyToFeature(col.featureId)"></i>
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{row.property.propertyCode}}</td>
          <td>{{locationMap.get(row.property.locationId)}}</td>
          @for (col of featureColumns; track col) {
            <td
              [ngClass]="{'disabled-checkbox': !row.featureMap.get(col.featureId)?.exists}">
              <p-checkbox
                [(ngModel)]="row.featureMap.get(col.featureId).status"
                binary="true"
                (onChange)="updatePropertyFeature(row.property, col.featureId, $event)">
              </p-checkbox>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  }
</div>
